import { SocketSlice } from "./types"
import { addUsageToLicense, setUserAddOn, setUserLicense } from "user/profile/slice"
import { AddOns, ID } from "@nova/constants"
import { License } from "@nova/schemas"

export default {
    events: {
        licenseUpdated: (store) => (updatedLicense: string) => {
            const license = JSON.parse(updatedLicense) as License | undefined
            store.dispatch(setUserLicense(license))
        },
        addOnUpdated: (store) => (updatedAddOn: string) => {
            const addOn = JSON.parse(updatedAddOn) as Partial<Record<AddOns, boolean>>
            store.dispatch(setUserAddOn(addOn))
        },
        usageUpdated: (store) => (usageToAdd: string) => {
            //pass licenseId to ensure we aren't accruing usage on the wrong license (if the license got re-assigned mid-upload)
            const usage = JSON.parse(usageToAdd) as { usageAmount: number; licenseId: ID }
            store.dispatch(addUsageToLicense(usage))
        },
    },
} as SocketSlice
